
(function () {
  'use strict';

  if (window.MBWishlist) return;

  var STORAGE_KEY = 'mb_guest_wishlist_v1';

  function getSaved() {
    try {
      var items = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(items) ? items.filter(function (item) {
        return item && item.id != null;
      }) : [];
    } catch (error) {
      return [];
    }
  }

  function save(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      return true;
    } catch (error) {
      window.alert('Your browser could not save the wishlist. Check that browser storage is enabled.');
      return false;
    }
  }

  function updateHearts() {
    var savedIds = getSaved().map(function (item) {
      return String(item.id);
    });

    document.querySelectorAll('.mb-wishlist-toggle').forEach(function (button) {
      var selected = savedIds.indexOf(button.getAttribute('data-product-id')) !== -1;
      var title = button.getAttribute('data-product-title') || 'product';

      button.classList.toggle('is-saved', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.setAttribute('aria-label', (selected ? 'Remove ' : 'Save ') + title + (selected ? ' from wishlist' : ' to wishlist'));
      button.title = selected ? 'Remove from wishlist' : 'Save to wishlist';
    });
  }

  function makeText(tag, className, value) {
    var element = document.createElement(tag);
    element.className = className;
    element.textContent = value;
    return element;
  }

  function renderWishlist() {
    var root = document.getElementById('mb-wishlist-page');
    if (!root) return;

    root.replaceChildren();

    var items = getSaved();

    root.appendChild(makeText('p', 'mb-wishlist-intro',
      'Your favourite pieces, saved here on this device.'));

    if (items.length === 0) {
      var empty = document.createElement('div');
      empty.className = 'mb-wishlist-empty';

      empty.appendChild(makeText('p', '', 'Your wishlist is empty for now.'));

      var shop = makeText('a', 'mb-wishlist-shop', 'SHOP ALL PIECES');
      shop.href = '/collections/all';

      empty.appendChild(shop);
      root.appendChild(empty);
      return;
    }

    var grid = document.createElement('div');
    grid.className = 'mb-wishlist-grid';

    items.forEach(function (item) {
      var card = document.createElement('article');
      card.className = 'mb-wishlist-card';

      var link = document.createElement('a');
      link.href = typeof item.url === 'string' && /^\/(?!\/)/.test(item.url)
        ? item.url
        : '/collections/all';

      if (
        typeof item.image === 'string' &&
        (/^https?:\/\//.test(item.image) ||
         /^\/\//.test(item.image) ||
         /^\/(?!\/)/.test(item.image))
      ) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        link.appendChild(img);
      }

      link.appendChild(makeText('h3', 'mb-wishlist-name', item.title || 'Product'));
      card.appendChild(link);
      card.appendChild(makeText('p', 'mb-wishlist-price', item.price || ''));

      var remove = makeText('button', 'mb-wishlist-remove', 'REMOVE');
      remove.type = 'button';
      remove.setAttribute('data-product-id', String(item.id));
      remove.setAttribute('aria-label', 'Remove ' + (item.title || 'product') + ' from wishlist');

      card.appendChild(remove);
      grid.appendChild(card);
    });

    root.appendChild(grid);
  }

  function refresh() {
    updateHearts();
    renderWishlist();
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.mb-wishlist-toggle');

    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      var product;

      try {
        product = JSON.parse(toggle.getAttribute('data-mb-product'));
      } catch (error) {
        return;
      }

      if (!product || product.id == null) return;

      var items = getSaved();
      var index = items.findIndex(function (item) {
        return String(item.id) === String(product.id);
      });

      if (index >= 0) {
        items.splice(index, 1);
      } else {
        items.push(product);
      }

      if (save(items)) refresh();
      return;
    }

    var remove = event.target.closest('.mb-wishlist-remove');

    if (remove) {
      event.preventDefault();

      var id = remove.getAttribute('data-product-id');

      if (save(getSaved().filter(function (item) {
        return String(item.id) !== id;
      }))) refresh();
    }
  });

  var style = document.createElement('style');

  style.textContent = `
.mb-wishlist-toggle{display:inline-flex!important;align-items:center;justify-content:center;width:34px;height:34px;padding:6px!important;border:0!important;background:transparent!important;box-shadow:none!important;color:#1c1c1c!important;cursor:pointer}
.mb-wishlist-toggle i{pointer-events:none}
.mb-wishlist-toggle.is-saved,.mb-wishlist-toggle.is-saved i{color:#c68f89!important}
.mb-wishlist-toggle:focus-visible,.mb-wishlist-remove:focus-visible{outline:2px solid #1c1c1c;outline-offset:3px}
#mb-wishlist-page{max-width:1200px;margin:24px auto 80px;padding:0 20px;color:#1c1c1c}
#mb-wishlist-page .mb-wishlist-intro{font:13px/1.6 'Open Sans',sans-serif;color:#77736e;margin:0 0 28px}
#mb-wishlist-page .mb-wishlist-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:24px 18px}
#mb-wishlist-page .mb-wishlist-card{text-align:left;min-width:0}
#mb-wishlist-page .mb-wishlist-card>a{display:block;text-decoration:none;color:#1c1c1c}
#mb-wishlist-page .mb-wishlist-card img{display:block;width:100%;aspect-ratio:3/4;object-fit:cover;border-radius:12px}
#mb-wishlist-page .mb-wishlist-name{margin:12px 0 5px;font:400 13px/1.5 'Open Sans',sans-serif;letter-spacing:.2px}
#mb-wishlist-page .mb-wishlist-price{margin:0 0 8px;font:13px 'Open Sans',sans-serif}
#mb-wishlist-page .mb-wishlist-remove{padding:3px 0;border:0;background:none;color:#77736e;font:11px 'Open Sans',sans-serif;letter-spacing:1px;text-decoration:underline;cursor:pointer}
#mb-wishlist-page .mb-wishlist-empty{padding:40px 0;text-align:center;font:13px 'Open Sans',sans-serif}
#mb-wishlist-page .mb-wishlist-shop{display:inline-block;margin-top:16px;padding:13px 22px;background:#1c1c1c;color:#fff;text-decoration:none;font:11px 'Open Sans',sans-serif;letter-spacing:1px}
@media(max-width:767px){#mb-wishlist-page .mb-wishlist-grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:22px 12px}}
`;

  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  window.addEventListener('pageshow', refresh);
  window.addEventListener('storage', refresh);

  window.MBWishlist = { refresh: refresh };
})();
